import React, { Component } from "react";
import './index.css';
import { connect } from 'react-redux';


class Options extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pageNo: 1,
            paginationLength: 1,
            questions: '',
        }
    }

    // This method is used to get Top Options UI
    getOptions(data) {
        let options = [];
        for (let i in data) {
            const option = "option-" + i;
            
            options.push(
                <div onClick={() => this.props.loading ? {} : this.props.onSelectOption(data[i],this.props.data.id, data[i].id, this.props.index,i)} key={i} title={data[i].option_name} className={option + " col custom-top-option custom-margin cursor-pointer "}>

                    {
                        this.props.respondentsAssessmentLoading === true && this.props.index === this.props.loading && this.props.data.user_response.assessment_option_id === data[i].id &&
                        <i className="fas fa-spinner fa-spin w-100 text-center text-white"></i>
                    }
                    {
                        (this.props.loading === null || this.props.respondentsAssessmentLoading === false) &&
                        <i className={this.props.data.user_response.assessment_option_id === data[i].id ? " fas fa-check text-white text-center w-100 py-1" : "visibility-hidden"}></i>
                    }
                    {
                        (this.props.respondentsAssessmentLoading === true || this.props.respondentsAssessmentLoading === false) && this.props.index !== this.props.loading &&
                        <i className={this.props.data.user_response.assessment_option_id === data[i].id ? " fas fa-check text-white text-center w-100 py-1" : "visibility-hidden"}></i>
                    }

                </div>
            )
        }
        return options
    }

    // This method is used to get Middle Options UI
    getMiddleOption(data) {

        let middleOptions = [];
        for (let i in data) {
           
            const option = "option-" + i;
            middleOptions.push(
                <div key={i} className={this.props.data.user_response.assessment_option_id === data[i].id ? option + " col custom-margin custom-middle-option " : " col bg-white "}>
                </div>
            )
        }
        return middleOptions;
    }

    // This method is used to get Below Options UI
    getBelowOption(data) {
        let belowOptions = [];
        for (let i in data) {

            belowOptions.push(
                <div key={i} className={this.props.data.user_response.assessment_option_id === data[i].id ? " col custom-margin text-center custom-top-option" : "col bg-white"}>
                    {
                        this.props.data.user_response.assessment_option_id === data[i].id &&
                        <small className="bold text-nowrap">{data[i].option_name}</small>
                    }
                </div>
            )
        }
        return belowOptions
    }



    render() {
        const { assessmentResponse, respondentsAssessmentLoading } = this.props;

       

     
        return (
            <div>
                <p className={Object.keys(this.props.data.user_response).length === 0 ? '' : 'text-success'}>{this.props.data.slNo}. {this.props.data.user_questions.question_statement_self}</p>
                <div className="my-2 d-flex flex-row custom-top-option">
                    {
                        this.getOptions(assessmentResponse.instument.instrument_options)
                    }
                </div>
                <div className="my-1 d-flex flex-row custom-middle-option">
                    {
                        this.getMiddleOption(assessmentResponse.instument.instrument_options)
                    }
                </div>

                <div className="my-1 d-flex flex-row custom-top-option text-center">
                    {
                        this.getBelowOption(assessmentResponse.instument.instrument_options)
                    }
                </div>
            </div>
        );

    }
}

function mapStateToProps(state) {
    const { getAssessmentLoading } = state.getAssessmentList;
    const assessmentResponse = (!getAssessmentLoading) ? state.getAssessmentList.data.data : '';

    const { respondentsAssessmentLoading } = state.respondentsAssessmentReducer;
    const respondentsAssessmentStatus = (!respondentsAssessmentLoading) ? state.respondentsAssessmentReducer.data.status : '';

    return {
        getAssessmentLoading,
        assessmentResponse,

        respondentsAssessmentLoading,
        respondentsAssessmentStatus,
    };
}

export default connect(mapStateToProps)(Options);


// WEBPACK FOOTER //
// ./src/_pages/Assessments/SingleRater/Options/index.jsx